/**
 * This file was auto-generated by @gonfalon/openapi/generate.ts.
 * Do not make direct changes to the file.
 *
 * If you have any questions, reach out to #ask-frontend.
 */

import { mergeHeaders } from 'openapi-fetch';

import { getClient } from '../../internal/client';
import type { operations } from '../openapi';

export type ListAgentOptimizationResultsByRunIdPathParams = NonNullable<
  operations['listAgentOptimizationResultsByRunId']['parameters']['path']
>;

export interface Input extends ListAgentOptimizationResultsByRunIdPathParams {
  apiVersion?: string;
}

export async function listAgentOptimizationResultsByRunId(
  { apiVersion, ...path }: Input,
  { headers, signal }: { headers?: HeadersInit; signal?: AbortSignal } = {},
) {
  return getClient().GET('/api/v2/projects/{projectKey}/agent-optimizations/{optimizationKey}/runs/{runId}/results', {
    params: { path },
    headers: apiVersion ? mergeHeaders(headers, { 'LD-API-Version': apiVersion }) : headers,
    signal,
  });
}
